<template>
  <form-panel
    v-loading.fullscreen.lock="fullscreenLoading"
    width="medium"
    @closePanel="closeModal">
    <preview-campaign
      :image="itemCampaign.img"
      :title="itemCampaign.name"
      :content="itemCampaign.content"/>
    <div
      v-if="profile.role === 'superadmin'"
      class="button-admin">
      <el-button
        :disabled="active"
        @click="showModalComments = true">
        Ver comentarios
      </el-button>
      <el-button @click="showNoteModal">
        Agregar comentarios
      </el-button>
      <el-button @click="updateCampaign('rejected')">
        Rechazar
      </el-button>
    </div>
    <div
      v-if="profile.role === 'superadmin'"
      class="button-admin-publish">
      <el-button
        type="primary"
        @click="updateCampaign('published')">
        Publicar
      </el-button>
    </div>
    <div
      v-if="profile.role === 'gerente_dealer'"
      class="button-admin">
      <el-button
        :disabled="active"
        @click="showModalComments = true">
        Ver comentarios
      </el-button>
      <el-button @click="updateCampaign('rejected')">
        Rechazar
      </el-button>
      <el-button
        type="primary"
        @click="updateCampaign('pre-approved')">
        Preaprobar
      </el-button>
    </div>
    <form-modal
      v-if="showModal"
      @closeModal="showNoteModal">
      <div class="note">
        <el-form
          ref="commentForm"
          :model="model"
          :rules="rules"
          @submit.native.prevent="onSubmitComment">
          <el-form-item
            prop="description"
            label="Agregar comentario">
            <el-input
              v-model="model.description"
              :rows="4"
              resize="none"
              type="textarea"/>
          </el-form-item>
          <div class="done">
            <el-button
              type="primary"
              native-type="submmit">Agregar</el-button>
          </div>
        </el-form>
      </div>
    </form-modal>
    <form-modal
      v-if="showModalComments"
      @closeModal="closeModalComment">
      <div class="comments">
        <h4>Comentarios</h4>
        <p
          v-for="(item, index) in comments"
          :key="index">{{ item.description }}</p>
      </div>
    </form-modal>
  </form-panel>
</template>

<script>
import FormPanel from '@/components/_shared/form-panel'
import FormModal from '@/components/_shared/form-modal'
import CommentModel from '@/models/campaigns/comment.model'
import PreviewCampaign from '@/modules/campaigns/_shared/preview-campaign'
export default {
  name: 'CampaignPreviewApprove',
  components: {
    FormPanel,
    FormModal,
    PreviewCampaign
  },
  props: {
    itemCampaign: {
      type: Object,
      default () {
        return {}
      }
    },
    profile: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      showModal: false,
      showModalComments: false,
      model: CommentModel.model(),
      rules: CommentModel.rules(),
      comments: [],
      contentCampaign: [],
      fullscreenLoading: false,
      active: true
    }
  },
  mounted () {
    this.fullscreenLoading = true
    Promise.all([
      this.$store.dispatch('campaignComments/query', {'filters[where][campaignId][eq]': this.itemCampaign.id}),
      this.$store.dispatch('campaignContents/query', {'filters[where][campaignId][eq]': this.itemCampaign.id})
    ]).then((data) => {
      this.comments = data[0].data.items
      this.contentCampaign = data[1].data.items
      this.active = !(this.comments.length > 0)
      for (let i = 0; i < this.contentCampaign.length; i++) {
        if (this.itemCampaign.id === parseInt(this.contentCampaign[i].campaignId)) {
          this.itemCampaign.img = `${process.env.API_URL_IMAGES}${this.contentCampaign[i].banner}`
          this.itemCampaign.content = this.contentCampaign[i].content
        }
      }
    }).catch(e => {
      this.$notify.error({
        message: 'Por favor, vuelve a intentarlo.'
      })
    }).finally(() => {
      this.fullscreenLoading = false
    })
  },
  methods: {
    onSubmitComment () {
      this.$refs.commentForm.validate(valid => {
        if (valid) {
          let save = {
            campaignId: this.itemCampaign.id,
            description: this.model.description
          }
          this.$store.dispatch('campaignComments/save', save)
            .then(response => {
              this.$message.success('Se agrego correctamente el comentario')
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {
              this.showModal = !this.showModal
              this.$store.dispatch('campaignComments/query', {
                limit: 1000,
                'filters[where][campaignId][eq]': this.itemCampaign.id
              }).then(({data}) => {
                this.comments = data.items
              })
              this.model = CommentModel.model()
            })
        }
      })
    },
    showNoteModal () {
      this.showModal = !this.showModal
    },
    closeModalComment () {
      this.showModalComments = false
    },
    closeModal () {
      this.$store.dispatch('app/toggleApprovePanel')
    },
    updateCampaign (value) {
      if (value === 'rejected' && this.profile.role === 'superadmin') {
        if (this.comments.length > 0) {
          this.saveCampaign(value)
        } else {
          this.$notify.error({
            title: 'Agregar comentarios',
            message: 'Por favor, agregar un comentario.'
          })
        }
      } else {
        this.saveCampaign(value)
      }
    },
    saveCampaign (value) {
      this.itemCampaign.img = undefined
      this.itemCampaign.username = undefined
      this.itemCampaign.status = value
      this.$store.dispatch('campaigns/save', this.itemCampaign)
        .then(({data}) => {
          if (value === 'published') {
            this.$message.success('La campaña fue aprobada.')
          } else if (value === 'rejected') {
            this.$message.error('La campaña fue rechazada.')
          } else if (value === 'pre-approved') {
            this.$message('La campaña fue pre-aprobada.')
          }
          this.$store.dispatch('app/toggleApprovePanel')
        })
        .catch(error => {
          this.$notify.error({
            title: 'Error al cambiar el estatus de la campaña.',
            message: 'Por favor, vuelve a intentarlo.'
          })
          return Promise.reject(error)
        })
    }
  }
}
</script>

<style scoped lang="scss">
  .button-admin {
    border-top: 2px solid #F1F1F1;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    button{
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
  .button-admin-publish{
    display: flex;
    flex-direction: row-reverse;
    justify-content: end;
    align-items: center;
    button {
      margin: 10px 10px 10px 0px;
    }
  }
  .note{
    padding: 50px 30px 30px 30px;
    position: relative;
  }
  .comments {
    padding: 20px;
    position: relative;
    width: 400px;
    max-height: 600px;
    overflow: auto;
    h4 {
      @include font-primary(18px, regular);
      margin: 0 0 25px 0;
    }
    p {
      @include font-primary(14px, regular);
      border-bottom: 2px solid #F1F1F1;
      padding: 6px 0 6px 10px;
      margin: 0;
      &:last-child {
        margin: 0;
        border-bottom: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/campaigns/campaign-preview-approve.vue